import styled from 'styled-components';

export const Fieldset = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme: { spacing } }) => spacing(2)};
`;
